import { LitDivider } from "./LitDivider";

interface Props {
  className?: string;
  inset?: boolean;
  subtle?: boolean;
}

export default function Divider({ className, inset, subtle }: Props) {
  return (
    <LitDivider
      role="separator"
      className={className}
      inset={inset}
      style={
        subtle
          ? ({ "--md-divider-color": "var(--md-sys-color-surface-container-high)" } as React.CSSProperties)
          : undefined
      }
    />
  );
}
